import { useTheme } from "@mui/material"
import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()

    return {
        container: {
            width: '100%',
            height: '100%',
            padding: '30px 50px 20px 2px',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            position: 'relative',
        },
        badge: ({counter}:{counter:number | null}) => ({
            ...(counter && counter > 0 ? {
                display: 'inline',
                marginLeft: '20px'
              } : {
                display: 'none',
              }),
          '& .MuiBadge-badge': {
            top: 0,
            right: '40px',
            background: 'black',
            fontSize: '.7rem',
          }
        }),
        buttonBadge:{
          '& .MuiSvgIcon-root': { 
            fontSize: '1em' 
          },
          '&:hover': {
            backgroundColor: 'c_grey.100',
            color: 'white'
          },
            fontSize: '1.5rem',
            padding: '6px',
        },
        hide: {
          visibility: 'hidden',
        },
        flex: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        title:{
            marginLeft: '5px'
        },
        header: {
            margin: '0px 5px 0px 5px'
        },
        date: {
            fontWeight: 'bold',
            fontSize: '16px',
            textAlign: 'end',
            padding: '0px',
            marginBottom: '-10px'
        },
        mainCash:{
            width: '74%',
            [breakpoints.down(1200)]: {
                width: "98%",
              },
        },
        pettyCash:{
            width: '24%',
            marginLeft: '30px',
            minWidth: '340px',
            [breakpoints.down(1200)]: {
                position: 'absolute',
              }
        },
        structure: {
            marginTop: '30px'
        },
        containerButoon :{
            display:'flex', 
            justifyContent: 'end', 
            marginTop:3
        },
        questionsContainer: {
            /* ...!!data && {
                height: '1000px',
            },
            ...!data && {
                height: '700px',
            }, */
            /* height: '60vh', */
            height: '650px',
            overflow: 'auto',
            marginBottom: '30px',
            scrollbarWidth: 'none',
            p: '4px',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        },
        filter: {
            '&.MuiButton-text': {
                color: 'black',
                fontWeight: '900',
                fontSize: '16px',
              },
        },
        button: {
            color: colors.color4,
        },
        marginTop: {
            marginTop: '200px'
        },
        inputsForm: ({flag}:{flag:boolean}) =>({
            display: flag ? 'block' : 'none', 
            padding: '10px 10px 0px 10px', 
            marginBottom: '40px',
            '& .showButon':{
                paddingBottom: '10px'
            }
        })
    }
}

export { useStyles }